import { CommonResponse } from 'models/common';
import moment from 'moment';
import { DATE_HYPHEN_FORMAT } from 'utils';
import axiosClient from 'utils/axiosClient';
import {
  AddGenresRequestPayload,
  AddMenusRequestPayload,
  AddSubGenresRequestPayload,
  Genre,
  MenuBookEditorDeletePayload,
  MenuBookEditorGetAllPayload,
  MenuData,
  SubMenu,
} from './models';

const menuBookEditorService = {
  getAll(payload: MenuBookEditorGetAllPayload): Promise<CommonResponse<Genre[]>> {
    const dataDate = moment(payload.data_date).format(DATE_HYPHEN_FORMAT);
    let url = `/menu-book-editor?data_date=${dataDate}&show_flg=${payload.show_flg}`;
    if (payload.menu_book_id) {
      url += `&menu_book_id=` + payload.menu_book_id;
    } else if (payload.course_id) {
      url += `&course_id=` + payload.course_id;
    }
    return axiosClient.get(url);
  },
  save(payload: {
    menu_book_id?: number;
    course_id?: number;
    genres: Genre[];
    deleted_subgenre_menu_ids: number[];
    data_date: Date;
  }): Promise<CommonResponse<any>> {
    const dataDate = moment(payload.data_date).format(DATE_HYPHEN_FORMAT);
    const url = `/menu-book-editor`;
    return axiosClient.patch(url, { ...payload, data_date: dataDate });
  },
  delete(payload: MenuBookEditorDeletePayload): Promise<CommonResponse<any>> {
    const url = `/menu-book-editor`;
    return axiosClient.delete(url, { data: payload });
  },
  addGenres(payload: AddGenresRequestPayload[]): Promise<CommonResponse<any>> {
    const url = `/menu-book-editor/add-genres`;
    return axiosClient.post(url, payload);
  },
  addSubGenres(payload: AddSubGenresRequestPayload[]): Promise<CommonResponse<any>> {
    const url = `/menu-book-editor/add-subgenres`;
    return axiosClient.post(url, payload);
  },
  addMenus(payload: AddMenusRequestPayload[]): Promise<CommonResponse<any>> {
    const url = `/menu-book-editor/add-menus`;
    return axiosClient.post(url, payload);
  },
  getMenuData(menuIds: number[], targetDate: Date): Promise<CommonResponse<MenuData[]>> {
    const dataDate = moment(targetDate).format(DATE_HYPHEN_FORMAT);
    let url = `/menu-book-editor/menu-data`;
    return axiosClient.post(url, {
      menu_ids: menuIds,
      data_date: dataDate,
    });
  },
  getSubMenuGroupData(subMenuGroupId: number, targetDate: Date): Promise<CommonResponse<SubMenu[]>> {
    const dataDate = moment(targetDate).format(DATE_HYPHEN_FORMAT);
    let url = `/menu-book-editor/sub-menu-group-data/${subMenuGroupId}?data_date=${dataDate}`;
    return axiosClient.get(url);
  },
};

export default menuBookEditorService;
